"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEditingLocale = exports.editingLocaleStorgeKey = exports.ConsumerDropdownLocaleSelector = exports.AdminDropdownLocaleSelector = exports.LocaleDropdown = exports.AdminLocaleSelector = exports.ConsumerLocaleSelector = void 0;
const react_1 = __importDefault(require("react"));
const locale_1 = require("utils/locale");
const selector_1 = require("../selector");
const hooks_1 = require("common/hooks");
const react_bootstrap_1 = require("react-bootstrap");
const LocaleSelector = ({ locale, locales = [], onChange, }) => {
    if (locales.length <= 1) {
        return react_1.default.createElement(react_1.default.Fragment, null, " ");
    }
    return (react_1.default.createElement(selector_1.DescreteSelector, { value: locale, options: locales.map((locale) => {
            var _a;
            return ({
                value: locale,
                title: ((_a = locale_1.messages[locale]) === null || _a === void 0 ? void 0 : _a.Language) || locale,
            });
        }), onChange: (value) => {
            onChange(value);
        } }));
};
const ConsumerLocaleSelector = ({ locales }) => {
    const [locale, setLocale] = (0, hooks_1.useContextLocale)();
    return (react_1.default.createElement(LocaleSelector, { locale: locale, locales: locales, onChange: (locale) => {
            setLocale(locale);
        } }));
};
exports.ConsumerLocaleSelector = ConsumerLocaleSelector;
const AdminLocaleSelector = ({ locales }) => {
    const [locale, setLocale] = (0, exports.useEditingLocale)();
    return (react_1.default.createElement("div", { style: { fontSize: "14px" } },
        react_1.default.createElement(LocaleSelector, { locale: locale, locales: locales, onChange: (locale) => {
                setLocale(locale);
            } })));
};
exports.AdminLocaleSelector = AdminLocaleSelector;
const LocaleDropdown = ({ locale: _locale, locales = [], onChange, children, }) => {
    return (react_1.default.createElement(react_bootstrap_1.Dropdown, null,
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", as: "div" }, children),
        " ",
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, null, locales === null || locales === void 0 ? void 0 : locales.map((locale) => {
            var _a;
            return (react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { key: locale, onClick: () => {
                    onChange(locale);
                } },
                react_1.default.createElement("span", { style: {
                        fontWeight: _locale === locale ? "bold" : "normal",
                    } }, (_a = locale_1.messages[locale]) === null || _a === void 0 ? void 0 : _a.Language)));
        }))));
};
exports.LocaleDropdown = LocaleDropdown;
const AdminDropdownLocaleSelector = ({ locales = [], }) => {
    const [locale, setLocale] = (0, exports.useEditingLocale)();
    return (react_1.default.createElement(exports.LocaleDropdown, { locale: locale, locales: locales, onChange: setLocale },
        react_1.default.createElement("span", { style: { fontSize: "0.8em", cursor: "pointer" }, className: "text-primary" },
            react_1.default.createElement("i", { className: "mdi mdi-earth" }),
            locale)));
};
exports.AdminDropdownLocaleSelector = AdminDropdownLocaleSelector;
const ConsumerDropdownLocaleSelector = ({ locales = [], children, }) => {
    const [locale, setLocale] = (0, hooks_1.useContextLocale)();
    return (react_1.default.createElement(exports.LocaleDropdown, { locale: locale, locales: locales, onChange: setLocale }, children));
};
exports.ConsumerDropdownLocaleSelector = ConsumerDropdownLocaleSelector;
exports.editingLocaleStorgeKey = "textIntl-editing-locale";
const useEditingLocale = () => {
    return (0, hooks_1.useSessionStorage)(exports.editingLocaleStorgeKey, "ja");
};
exports.useEditingLocale = useEditingLocale;
